import {
	Button,
	Column,
	Icon,
	Text,
} from 'native-base';
import {
	FontAwesome5,
} from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import withRedux from '../OneHat/data/hoc/withRedux';
import testProps from '../OneHat/functions/testProps';
import _ from 'lodash';

function GatedMessage(props) {
	const {
			user,
		} = props,
		navigation = useNavigation();

	return <Column
				bg="trueGray.300"
				w="100%"
				flex={1}
				justifyContent="center"
				alignItems="center"
			>
				<Text
					fontSize={25}
					textAlign="center"

				>{user ? 'Content unavailable in your WSCinME account.' : "Content unavailable.\nLogin to access your WSCinME account."}</Text>

				<Button
					{...testProps('accountBtn')}
					leftIcon={<Icon as={FontAwesome5} name="user-alt" />}
					onPress={() => navigation.navigate('Account')}
					bg="primary.800"
					mb={3}
				>Account</Button>
			</Column>;
}

export default withRedux(GatedMessage, [
	'user',
]);